import onResize from '../helpers/on-resize.js';

function setVh() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

setVh();
onResize(setVh);
